import * as monacoEditor from 'monaco-editor';

import { CodeEditorSize } from './types';

export const MAIN_CLASS_NAME = 'code-editor-expandable';
export const READONLY_CLASS_NAME = `${MAIN_CLASS_NAME}_readonly`;
export const TOOLBAR_CLASS_NAME = `${MAIN_CLASS_NAME}__toolbar`;
export const EDITOR_CLASS_NAME = `${MAIN_CLASS_NAME}__editor`;
export const FULLSCREEN_CLASS_NAME = `${MAIN_CLASS_NAME}_fullscreen`;

export const DEFAULT_EDITOR_SIZE = CodeEditorSize.XS;

export const MONACO_BASE_EDITOR_OPTIONS: monacoEditor.editor.IStandaloneEditorConstructionOptions = {
  tabSize: 2,
  glyphMargin: false,
  showFoldingControls: 'mouseover',
  wordWrap: 'on',
  scrollBeyondLastLine: false,
  wordBasedSuggestions: false,
  padding: { top: 4, bottom: 4 }, // NOTE: for better fit inside parent's border; can't be fully achieved with styles.
};

export const MONACO_FULL_EDITOR_OPTIONS: monacoEditor.editor.IStandaloneEditorConstructionOptions = {
  ...MONACO_BASE_EDITOR_OPTIONS,
  folding: true,
  lineNumbers: 'on',
  minimap: { enabled: true },
};

export const MONACO_LITE_EDITOR_OPTIONS: monacoEditor.editor.IStandaloneEditorConstructionOptions = {
  ...MONACO_BASE_EDITOR_OPTIONS,
  folding: false,
  lineNumbers: 'off',
  minimap: { enabled: false },
  lineDecorationsWidth: 0,
  lineNumbersMinChars: 0,
};
